import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { API_URLS, ApiUrlService } from 'libs/ng-components/utils/src/lib/services/api-url.service';
import moment from 'moment';
import { BaseTableComponent } from '../base-table.component';

@Component({
  selector: 'ebw-monorepo-fiber-history-modal',
  templateUrl: './fiber-history-modal.component.html',
  styleUrls: ['./fiber-history-modal.component.scss']
})
export class FiberHistoryModalComponent extends BaseTableComponent<any> implements OnInit {
  public fibra;

  constructor(private _apiUrlService: ApiUrlService, @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this._exportFilename = 'export-storico-fibre';
    this.fibra = this.data.fibra;

    this.config = { url: this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.FIBER.HISOTRY) };
  }

  ngOnInit(): void {
    super.ngOnInit();

    this._exportApi = {
      csv: this._apiUrlService.createUrl(API_URLS.MAP.EXPORT.CSV),
      html: this._apiUrlService.createUrl(API_URLS.MAP.EXPORT.HTML)
    };

    this.init();
  }

  protected fetchData(customFilter?: Record<string, any>): void {
    this.resetComponentProperties();
    let filters = { ...this.getFilters(), ...customFilter };

    this._utilsService
      .postRequest(
        this._apiUrlService.createUrl(API_URLS.FIBER_JOINTS.FIBER.HISOTRY),
        filters,
        false,
        {},
        'application/json'
      )
      .subscribe({
        next: (resp: any) => {
          this.totalCount = resp.numRows;
          this.dataGrid = resp.records;
        },
        error: (err) => {
          this._ebwModal.openErrorModal({
            title: this._translateService.instant('common.error'),
            content: err.message
          });
        }
      });
  }

  protected initializeTable(): void {
    this.columnsGrid = [
      {
        header: this._translateService.instant('map.sidebar.fibra.table.user'),
        field: 'id_utente',
        sortable: false,
        pinned: 'left'
      },
      {
        header: this._translateService.instant('map.sidebar.fibra.table.stato'),
        field: 'stato',
        sortable: false
      },
      {
        header: this._translateService.instant('map.sidebar.fibra.table.updated_at'),
        field: 'timestamp',
        formatter: (data: any) =>
          `<span class="date-field">${moment(data.timestamp).local().format('DD/MM/YYYY HH:mm')}</span>`
      }
    ];
  }

  protected getFilters(limit = this.pageSize, offset = this.offset): Record<string, any> {
    let nextFilters = {
      limit,
      offset
    };

    if (this._currentSort) {
      nextFilters['order_by'] = this._currentSort.field;
      nextFilters['order'] = this._currentSort.direction;
    }

    let filters = {
      id_fibra: this.data.fibra.id
    };

    if (filters && Object.keys(filters).length > 0) {
      Object.keys(filters).forEach((key) => {
        if (!filters[key]) {
          return;
        }
        nextFilters[key] = filters[key];
      });
    }

    return nextFilters;
  }

  protected formatExportData(data: any[], excel: boolean = false) {
    return this.defaultFormatData(data, excel);
  }
}
